import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import type { ToolsError } from "../../model/types";
import { useCanReload } from "../store/useCanReload";
import { useEnabledToolsState, useToolsLoading, useWorkspaceToolsStore } from "../store/useWorkspaceToolsStore";

/** A failed fetch leaves the tools on disk shown, even when access is refused: no reason to stop the user. */
export const isUpdateFailure = (error: ToolsError): boolean => error.kind === "fetch";

const useTellsFailures = (): boolean => {
	const loading = useToolsLoading();
	const isLogged = PageDataContextService.value.isLogged;
	const canReload = useCanReload();
	return canReload && isLogged && !loading;
};

export const useUnseenError = (): ToolsError | null => {
	const error = useEnabledToolsState()?.error;
	const dismissedSeq = useWorkspaceToolsStore((store) => store.dismissedErrorSeq);
	const tellsFailures = useTellsFailures();
	return tellsFailures && error && error.seq !== dismissedSeq ? error : null;
};

export const useUnseenRefusal = (): ToolsError | null => {
	const refusal = useWorkspaceToolsStore((store) => store.refusal);
	const tellsFailures = useTellsFailures();
	return tellsFailures ? refusal : null;
};
